import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/ccm/importer/ccmImporterActions';

export default importerReducers(actions);
